import axios from 'axios';

const dataURL = `${process.env.PUBLIC_URL}/data/v7.json`;

export default () => {
  return axios.get(dataURL).then(response => response.data);
};



// WEBPACK FOOTER //
// ./src/api/index.js